module.exports = __webpack_public_path__ + "img/5f_r_goodsmile.99248737.png";